/**
 * ## Tabs Controller
 *
 * @module src/controllers/tabs
 */

"use strict";

const chart = require("../../components/chart");
const layout = require("../../components/layout");
const conf = require("../../config");
const moment = require("moment-timezone");

let currentTab = "waiting";

const hideKeyboard = () => {
  setTimeout(() => {
    layout.hideKeyboard();
  }, 100);
};

/** Init
 */
const init = (kd) => {
  $(".tab_standard, .tab_btn").off();
  $(".tab_standard, .tab_btn").fastClick((e) => {
    // e.stopPropagation();
    currentTab = $(`#${e.target.id}`).data("tab");
    tab(kd, currentTab);
    hideKeyboard();
  });

  $(".tab_wide").off();
  $(".tab_wide").fastClick((e) => {
    currentTab = $(`#${e.target.id}`).data("tab");
    switch (currentTab) {
      case "waiting":
      case "reservations":
      case "notes":
      case "stats": {
        tab(kd, currentTab);
        break;
      }
      default: {
        tab(kd, currentTab);
        // LEFT OFF HERE
        if (conf.vars.ui === "standard") {
          layout.toggleSidebarMax();
        }
        break;
      }
    }
    hideKeyboard();
  });

  $(".waitlist_tabs_top").off();
  $(".waitlist_tabs_top").fastClick((e) => {
    const tabName = $(`#${e.target.id}`).data("tab");
    highlight(`#waitlist_tabs_${tabName}`, ".waitlist_tab");
    highlight(`#waiting_${tabName}`, ".waiting_box");
    hideKeyboard();
  });

  highlight("#waitlist_tabs_next", ".waitlist_tab");
  highlight("#waiting_next", ".waiting_box");

  $(".reservation_tabs_top").off();
  $(".reservation_tabs_top").fastClick((e) => {
    const tabName = $(`#${e.target.id}`).data("tab");
    highlight(`#reservation_tabs_${tabName}`, ".reservation_tab");
    highlight(`#reservation_${tabName}`, ".reservation_box");
    hideKeyboard();
  });

  highlight("#reservation_tabs_today", ".reservation_tab");
  highlight("#reservation_today", ".reservation_box");

  $(".stats_tabs_top").off();
  $(".stats_tabs_top").fastClick((e) => {
    const tabName = $(`#${e.target.id}`).data("tab");
    highlight(`#stats_tabs_${tabName}`, ".stats_tab");
    highlight(`#stats_${tabName}`, ".stats_box");
  });

  highlight("#stats_tabs_hour", ".stats_tab");
  highlight("#stats_hour", ".stats_box");

  $("#layout_sidebar_header_expand").off();
  $("#layout_sidebar_header_expand").fastClick(() => {
    if (layout.getIsMin()) {
      layout.toggleSidebarMin();
    } else if (!layout.getIsExpanded()) {
      checkWideTab(kd);
    } else {
      checkStandardTab(kd);
    }
    hideKeyboard();
  });
  $("#layout_chart_header_expand").off();
  $("#layout_chart_header_expand").fastClick(() => {
    layout.toggleSidebarMin();
    hideKeyboard();
  });
  $("#layout_sidebar_open_max").off();
  $("#layout_sidebar_open_max").fastClick(() => {
    checkStandardTab(kd);
    hideKeyboard();
  });
  $("#layout_sidebar_open_min").off();
  $("#layout_sidebar_open_min").fastClick(() => {
    layout.toggleSidebarMin();
    hideKeyboard();
  });

  kd.on("activity.update", () => {
    getWaitingCount(kd);
  });

  kd.on("reservation.update", () => {
    getReservationCount(kd);
  });

  getWaitingCount(kd);
  getReservationCount(kd);

  // load intial tab

  if (conf.vars.ui === "reservation") {
    formatRes();
    tab(kd, "reservations");
  } else if (conf.vars.ui === "waitlist") {
    formatWait();
    tab(kd, "waiting");
  } else {
    tab(kd, "waiting");
  }
};

const formatRes = () => {
  $("#tab_wide_waiting").css("display", "none");
  $("#tab_wide_stats").css("display", "none");
  $("#tab_wide_direct").css("display", "none");
  $("#tab_wide_filter").css("display", "none");
  $("#tab_wide_sections").css("display", "none");
  $("#tab_wide_precheck").css("display", "none");
  $("#tab_wide_seated").css("display", "none");
  $("#tab_wide_noshows").css("display", "none");
};

const formatWait = () => {
  $("#tab_wide_reservations").css("display", "none");
  $("#tab_wide_stats").css("display", "none");
  $("#tab_wide_direct").css("display", "none");
  $("#tab_wide_filter").css("display", "none");
  $("#tab_wide_sections").css("display", "none");
  $("#tab_wide_seated").css("display", "none");
  $("#tab_wide_resnoshows").css("display", "none");
};

const getWaitingCount = (kd) => {
  const result = kd.where("activity", (obj) => {
    if (obj.hasOwnProperty("status") && obj.status >= 1 && obj.status <= 2) {
      return true;
    }
  });
  $("#tab_count_wide_waiting").html(result.length);
  $("#tab_count_standard_waiting").html(result.length);
  return result.length;
};

const getReservationCount = (kd) => {
  const result = kd.where("reservation", (obj) => {
    if (
      obj.date === parseInt(moment().startOf("day").format("X"), 10) &&
      obj.status === 1 &&
      obj.requireConfirmation === 0
    ) {
      return true;
    }
  });
  $("#tab_count_wide_reservations").html(result.length);
  $("#tab_count_standard_reservations").html(result.length);
  return result.length;
};

/** Tab
 */
const tab = (kd, tabName, opt) => {
  ga(
    "send",
    "event",
    "tab",
    tabName,
    `/${kd.localstore.data.credentials.site_id}`
  );
  if (
    typeof opt !== "undefined" &&
    opt.hasOwnProperty("minimal") &&
    opt.minimal &&
    opt.size
  ) {
    $("#titlebar_standard_direct").css("display", "none");
    $("#directseat_1").css("display", "none");
    $("#directseat_2").css("float", "none");
    $("#directseat_2").css("width", "auto");
    $(".directseat_suggested").css("display", "none");
    $(`#directseat_suggested${Math.round(opt.size / 2) * 2}`).css(
      "display",
      "block"
    );
    if (opt.size > 8) {
      $("#directseat_head_title_id").css("display", "none");
    } else {
      let table = $(
        `#directseat_suggested${Math.round(opt.size / 2) * 2}`
      ).data("table");
      if (!table) {
        table = -1;
      }
      // apply highlight directly to chart through dom?
      $(`.table_lib[data-table="${table}"] > .table_base`).addClass(
        "table_highlight"
      );
      chart.roomByTable(kd, table);
      $(`.table_lib[data-table="${table}"] > .table_base`).addClass(
        "table_highlight"
      );
      TweenMax.to(`.table_lib[data-table="${table}"] > .table_base`, 0, {
        scale: 0,
      });
      TweenMax.to(
        `.table_lib[data-table="${table}"] > .table_base`,
        conf.vars.interfaceSpeed * 2,
        {
          scale: 1,
          ease: Elastic.easeOut,
        }
      );
    }
  } else {
    $("#titlebar_standard_direct").css("display", "block");
    $("#directseat_1").css("display", "block");
    $("#directseat_2").css("float", "left");
    $("#directseat_2").css("width", "60px");
    $(".directseat_suggested").css("display", "block");
    $("#directseat_head_title_id").css("display", "block");
    $(".table_lib > .table_dash").css("display", "block");
    $(".table_lib > .table_base").removeClass("table_highlight");
  }
  // tab highlighting
  $(".tab_standard").removeClass("tab_highlight");
  $(`#tab_standard_${tabName}`).addClass("tab_highlight");

  $(".tab_wide").removeClass("tab_highlight");
  $(`#tab_wide_${tabName}`).addClass("tab_highlight");

  // title showing
  $(".titlebar_standard").css("display", "none");
  $(`#titlebar_standard_${tabName}`).css("display", "block");

  $(".titlebar_wide").css("display", "none");
  $(`#titlebar_wide_${tabName}`).css("display", "block");

  // title showing
  $(".content_standard").css("display", "none");
  $(`#content_standard_${tabName}`).css("display", "block");

  $(".content_wide").css("display", "none");
  $(`#content_wide_${tabName}`).css("display", "block");

  switch (tabName) {
    case "reservations": {
      $("#tab_btn_addreservation").css("display", "block");
      $("#tab_btn_addparty").css("display", "none");
      $("#tab_btn_addreservation_wide").css("display", "block");
      $("#tab_btn_addparty_wide").css("display", "none");
      break;
    }
    default: {
      $("#tab_btn_addreservation").css("display", "none");
      $("#tab_btn_addparty").css("display", "block");
      $("#tab_btn_addreservation_wide").css("display", "none");
      if (conf.vars.ui === "reservation") {
        $("#tab_btn_addparty_wide").css("display", "none");
      } else {
        $("#tab_btn_addparty_wide").css("display", "block");
      }
      break;
    }
  }

  // show content_wide_footer or not

  switch (tabName) {
    case "waiting":
    case "reservations": {
      break;
    }
    case "notes": {
      if (!layout.getIsExpanded()) {
        layout.sidebarMaxOpen(conf.vars.interfaceSpeed / 2);
      }
      break;
    }
    default: {
    }
  }

  $(window).trigger("resize");
};

const checkWideTab = (kd) => {
  switch (currentTab) {
    case "waiting":
    case "reservations":
    case "stats": {
      layout.sidebarMaxOpen(conf.vars.interfaceSpeed / 2);
      break;
    }
    default: {
      tab(kd, "reservations");
      layout.sidebarMaxOpen(conf.vars.interfaceSpeed / 2);
      break;
    }
  }
};

const checkStandardTab = (kd) => {
  switch (currentTab) {
    case "notes": {
      tab(kd, "waiting");
      layout.toggleSidebarMax();
      break;
    }
    default: {
      layout.toggleSidebarMax();
      break;
    }
  }
};

/** Highlight
 * show a div by id and hide by class
 */
const highlight = (showID, hideClass) => {
  $(hideClass).css("display", "none");
  $(showID).css("display", "block");
  return true;
};

module.exports = {
  init,
  tab,
  highlight,
  layout,
  checkWideTab,
  checkStandardTab,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/tabs/index.js
 **/